import { createAction, createReducer } from '@reduxjs/toolkit';
import toggleBoolean from '../../utils/toggleBoolean.js';

const OPEN = createAction('drawer/open');
const CLOSE = createAction('drawer/close');
const TOGGLE = createAction('drawer/toggle');

export const actions = {
  OPEN,
  CLOSE,
  TOGGLE,
};

function openHandler() {
  return true;
}

function closeHandler() {
  return false;
}

const reducer = createReducer(false, {
  [OPEN]: openHandler,
  [CLOSE]: closeHandler,
  [TOGGLE]: toggleBoolean,
});

export default reducer;
